/**
 * @file Amelioration par etoiles (par slot d'equipement) : 20 niveaux, 50 StarGem/essai, echec possible, garantie progressive des le niveau 18.
 */
import { Decimal } from '@shared/bignum';
import { fail, ok } from '@shared/types';
import type { Result } from '@shared/types';
import type { SimContext } from '../Context';
import { starMultiplier, starSuccessChance } from '../balance/formulas';

export class StarService {
  constructor(private readonly ctx: SimContext) {}

  level(slot: number): number {
    return this.ctx.data.stars.levels[slot] ?? 0;
  }

  chance(slot: number): number {
    return starSuccessChance(this.ctx.config.balance, this.level(slot), this.ctx.data.stars.pityFails[slot] ?? 0);
  }

  multiplier(slot: number): Decimal {
    return starMultiplier(this.ctx.config.balance, this.level(slot));
  }

  /** Essai d'amelioration : le cout est debite dans TOUS les cas ; garantie progressive des le niveau pityFromLevel. */
  upgrade(slot: number): Result<{ success: boolean }> {
    const ctx = this.ctx;
    const cfg = ctx.config.balance.stars;
    if (!ctx.services.unlocks.isFeatureUnlocked('stars')) return fail('locked');
    if (slot < 0 || slot >= ctx.data.stars.levels.length) return fail('invalidArgument');
    const level = this.level(slot);
    if (level >= cfg.maxLevel) return fail('maxLevel');
    const spent = ctx.wallet.spend({ starGem: new Decimal(cfg.gemsPerLevel) }, 'star');
    if (!spent.ok) return spent;
    const success = ctx.rng.misc.next() < this.chance(slot);
    if (success) {
      ctx.data.stars.levels[slot] = level + 1;
      ctx.data.stars.pityFails[slot] = 0;
      ctx.bus.emit('ModifiersDirty', { source: `star:${slot}` });
    } else {
      ctx.data.stars.pityFails[slot] = (ctx.data.stars.pityFails[slot] ?? 0) + 1;
    }
    ctx.bus.emit('StarUpgraded', { slot, success, level: this.level(slot) });
    return ok({ success });
  }
}
